import React from "react";
import ReactDOM from "react-dom";
import thunk from "redux-thunk";
import _ from "lodash";
import ReactGA from "react-ga";
import { Router, Route, IndexRoute, browserHistory } from "react-router";
import { MuiThemeProvider, getMuiTheme } from "material-ui/styles";
import darkTheme from "material-ui/styles/baseThemes/darkBaseTheme";
import injectTapEventPlugin from "react-tap-event-plugin";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import App from "./App";
import reducers from "./reducers";
import "./index.css";
import decorateWindow from "./components/decorateWindow";
import * as pages from "./pages";
import dataService from "./data/DataService";
import Restaurants from "./pages/Restaurants";
import Connect from "./pages/Connect";
import requireAuth from "./components/requireAuth";
import Login from "./pages/Login";
import TokenLogin from "./pages/TokenLogin";
import Signup from "./pages/SignUp";
import CreateRestaurant from "./pages/Settings";
import Claim from "./pages/Claim";
import { fade } from "./utils/colorManipulator";
import withTracker from "./components/withTracker";
import Subscribe from "./pages/Subscribe";
import QrCodes from "./pages/QrCodes";

injectTapEventPlugin();

ReactGA.initialize("UA-130179876-2");

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk, dataService))
);

const externalRoutes = {
  restaurants: {
    title: "Restaurants",
    component: requireAuth(Restaurants),
    path: "/",
  },
  login: {
    title: "Login",
    component: Login,
    path: "/login",
  },
  tokenLogin: {
    title: "Login",
    component: TokenLogin,
    path: "/login/:token",
  },
  signup: {
    title: "Signup",
    component: Signup,
    path: "/signup",
  },
  connect: {
    title: "Connect",
    component: <div />,
    path: "/connect",
  },
};

const claim = {
  title: "Claim Restaurant",
  component: decorateWindow(Claim),
  path: "/:restaurantId/claim",
};

const fullWhite = "#ffffff";
const appColor = "#48A9A6";

const theme = getMuiTheme({
  palette: {
    primary1Color: appColor,
    primary2Color: "#00796B",
    primary3Color: "#cee5e3",
    accent1Color: appColor,

    // textColor: fullWhite,
    // secondaryTextColor: fade(fullWhite, 0.7),
    // alternateTextColor: '#303030',
    // canvasColor: '#303030',
    // borderColor: fade(fullWhite, 0.3),
    // disabledColor: fade(fullWhite, 0.3),
    // pickerHeaderColor: fade(fullWhite, 0.12),
    clockCircleColor: fade(fullWhite, 0.12),

    // accent2Color: grey100,
    // accent3Color: grey500,
    // textColor: '#212121',
    // alternateTextColor: '#ffffff',
    // canvasColor: white,
    // borderColor: grey300,
    // disabledColor: fade('#212121', 0.3),
    pickerHeaderColor: appColor,
    // clockCircleColor: fade(darkBlack, 0.07),
    // shadowColor: fullBlack,
  },
});

function noop() {}

if (process.env.NODE_ENV !== "development") {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

ReactDOM.render(
  <MuiThemeProvider muiTheme={getMuiTheme(theme)}>
    <Provider store={store}>
      <Router history={browserHistory}>
        <Route
          path={claim.path}
          exact
          component={requireAuth(claim.component)}
        />
        <Route path="/onlineorder/:restaurantId" exact component={Login} />
        <Route path="/connect" exact component={requireAuth(Connect)} />
        <Route path="/" exact component={withTracker(App)}>
          <IndexRoute component={requireAuth(Restaurants)} />
          <Route
            path="/create-restaurant"
            exact
            component={requireAuth((props) => (
              <CreateRestaurant {...props} create={true} />
            ))}
          />
          <Route path="/signup" exact component={Signup} />
          <Route path="/login" exact component={Login} />
          <Route path="/login/:token" exact component={TokenLogin} />
          <Route path="/subscribe" exact component={requireAuth(Subscribe)} />
          <Route exact path="/:restaurantId">
            <IndexRoute component={requireAuth(QrCodes)} />
            {_.map(pages, (page) => (
              <Route path={page.path} component={requireAuth(page.component)} />
            ))}
          </Route>
        </Route>
      </Router>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js